import React from "react";
import { compose, branch, renderComponent } from "recompose";
import Page from "./Page";
import { Trans } from "react-i18next";

export const withSpinner = (test, { title } = {}) =>
  compose(
    branch(
      test,
      renderComponent(() => (
        <Page title={title}>
          <p className="small">
            <span className="fa fa-spinner fa-spin" /> <Trans>Loading...</Trans>
          </p>
        </Page>
      ))
    )
  );

export default withSpinner;
